import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

// --- IMPORTS COMPONENTES ---
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import LiquidacionEjecucionAutocomplete from "../../../components/autocomplete/LiquidacionEjecucionAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";

// --- IMPORTS API / AUTH ---
import apiRoutes from "../../../api/apiRoutes";
import { appFetchBlob } from "../../../utils/http";

// --- CONSTANTES ---
const FORMATO_OPCIONES = [
  { id: "EXCEL", label: "EXCEL" },
  { id: "PDF", label: "PDF" },
];

const TIPO_TARJETA_OPCIONES = [
  { id: "CLIENTE", label: "Cliente" },
  { id: "MAESTRA", label: "Maestra" },
  { id: "OTROS", label: "Otros" },
];

export default function ReporteDetalleUtilizacionTarjetas() {
  const [descargando, setDescargando] = useState(false);

  // --- ESTADOS DEL FORMULARIO ---
  const [cliente, setCliente] = useState(null);
  const [eess, setEess] = useState(null);
   // --- FECHAS POR DEFECTO (MES ANTERIOR) ---
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  
  // restar 1 mes manteniendo el mismo día
  const haceUnMes = new Date(hoy);
  haceUnMes.setMonth(haceUnMes.getMonth() - 1);
  
  // ajuste por meses con menos días (ej: 31 → 28/29)
  if (haceUnMes.getDate() !== hoy.getDate()) {
    haceUnMes.setDate(0); // último día del mes anterior
  }
  
  const formatDate = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  
  const [fechaDesde, setFechaDesde] = useState(formatDate(haceUnMes));
  const [fechaHasta, setFechaHasta] = useState(formatDate(hoy));
  const [nroTarjeta, setNroTarjeta] = useState("");
  const [liqDesde, setLiqDesde] = useState(null);
  const [liqHasta, setLiqHasta] = useState(null);
  const [producto, setProducto] = useState(null);
  const [centroCosto, setCentroCosto] = useState("");
  const [tipoTarjeta, setTipoTarjeta] = useState("");
  const [formato, setFormato] = useState("EXCEL");

  // --- HANDLER CONSULTAR ---
  const handleConsultar = async () => {
    setDescargando(true);
    try {
      const params = new URLSearchParams();
      if (cliente?.id) params.append("clienteId", cliente.id);
      if (eess?.id) params.append("eessId", eess.id);
      if (fechaDesde) params.append("fechaDesde", fechaDesde);
      if (fechaHasta) params.append("fechaHasta", fechaHasta);
      if (nroTarjeta) params.append("tarjetaNumero", nroTarjeta);
      if (liqDesde?.id) params.append("liquidacionDesdeId", liqDesde.id);
      if (liqHasta?.id) params.append("liquidacionHastaId", liqHasta.id);
      if (producto?.id) params.append("productoId", producto.id);
      if (centroCosto) params.append("centroCosto", centroCosto);
      if (tipoTarjeta) params.append("tipo", tipoTarjeta);

      const url =
        formato === "PDF"
          ? apiRoutes.transacciones.exportarPdf(params)
          : apiRoutes.transacciones.exportar(params);

      const { blob, filename } = await appFetchBlob(
        url,
        { method: "GET" },
        { showLoading: false }
      );

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      const timestamp = new Date().getTime();
      const extension = formato === "PDF" ? "pdf" : "xlsx";
      a.download = filename || `Detalle_Utilizacion_${timestamp}.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error(error);
      if (error.status !== 401) {
        alert("No se pudo descargar el reporte.");
      }
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div className="w-full p-4 md:p-6">
      <div className="bg-white border rounded-md shadow-sm">
        {/* HEADER */}
        <div className="px-4 md:px-6 py-4 border-b flex flex-col md:flex-row md:items-center md:justify-between bg-gray-50 gap-2">
          <h2 className="text-lg md:text-xl font-semibold text-gray-800">
            Detalle de Utilización de Tarjetas
          </h2>
          <div className="text-sm font-bold text-red-600 bg-red-50 px-3 py-1 rounded-full border border-red-200">
            * Campos obligatorios.
          </div>
        </div>

        {/* BODY */}
        <div className="p-4 md:p-6">
          <div className="bg-gray-100 p-4 md:p-8 rounded-md space-y-4 md:space-y-5 max-w-5xl mx-auto">
            {/* 1. CLIENTE */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Cliente:</label>
  <div className="w-full"><ClienteAutocomplete value={cliente} onChange={setCliente} /></div>
</div>

            {/* 2. EE.SS. */}
           <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">EE.SS.:</label>
  <div className="w-full"><EessAutocomplete value={eess} onChange={setEess} /></div>
</div>

            {/* 3. FECHAS */}
         <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Fecha Desde*:</label>
  <input type="date" className="input w-full" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
</div>
<div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Fecha Hasta*:</label>
  <input type="date" className="input w-full" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
</div>

            {/* 4. NRO TARJETA */}
           <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Nro. Tarjeta:</label>
  <input type="text" className="input w-full" placeholder="Ingrese número de tarjeta..." value={nroTarjeta} onChange={(e) => setNroTarjeta(e.target.value)} />
</div>

            {/* 5. LIQUIDACIONES (Convertido a vertical) */}
           <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Liquidación Desde:</label>
  <div className="w-full"><LiquidacionEjecucionAutocomplete value={liqDesde} onChange={setLiqDesde} /></div>
</div>
<div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Liquidación Hasta:</label>
  <div className="w-full"><LiquidacionEjecucionAutocomplete value={liqHasta} onChange={setLiqHasta} /></div>
</div>

            {/* 6. PRODUCTO Y CENTRO COSTO (Convertido a vertical) */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Cód. producto:</label>
  <div className="w-full"><ProductoAutocomplete value={producto} onChange={setProducto} /></div>
</div>
<div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Centro de Costo:</label>
  <input type="text" className="input w-full" value={centroCosto} onChange={(e) => setCentroCosto(e.target.value)} />
</div>

            {/* 7. TIPO Y FORMATO (Convertido a vertical) */}
           <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Tipo:</label>
  <select className="input w-full" value={tipoTarjeta} onChange={(e) => setTipoTarjeta(e.target.value)}>
    <option value="">-- Todos --</option>
    {TIPO_TARJETA_OPCIONES.map((t) => (
      <option key={t.id} value={t.id}>{t.label}</option>
    ))}
  </select>
</div>
<div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
  <label className="md:w-60 shrink-0 font-bold text-gray-700">Formato:</label>
  <select className="input w-full" value={formato} onChange={(e) => setFormato(e.target.value)}>
    {FORMATO_OPCIONES.map((f) => (
      <option key={f.id} value={f.id}>{f.label}</option>
    ))}
  </select>
</div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="px-4 md:px-6 py-4 border-t bg-gray-50 flex justify-start">
          <button
            onClick={handleConsultar}
            disabled={descargando}
            className={`flex items-center gap-2 text-white font-semibold py-2 px-10 rounded shadow transition-all ${
              descargando
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-800 hover:bg-green-900"
            }`}
          >
            {descargando ? (
              "Generando..."
            ) : (
              <>
                <FaSearch className="text-sm" /> Consultar
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
